import { render, staticRenderFns } from "./RoleConfigurationModal.vue?vue&type=template&id=6d5b6ccc&"
import script from "./RoleConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./RoleConfigurationModal.vue?vue&type=script&lang=js&"
import style0 from "./RoleConfigurationModal.vue?vue&type=style&index=0&id=6d5b6ccc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QForm,QItemLabel,QInput,QSelect,QTable,QTd,QCheckbox,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QForm,QItemLabel,QInput,QSelect,QTable,QTd,QCheckbox,QCardActions,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
